/**
 * @ngdoc run
 * @memberof mercury.startup
 * @name UserDataInitialization
 * @description A run block that will redirect unauthenticated users to the login
 *   page, or otherwise will establish appropriate auth tokens in the $http module
 *   so that any API requests made will be correctly authenticated.
 */
angular.module('mercury.startup')
.run(["authService", "$http", "$location", "$state", "$rootScope", "userinfo", "$window", "logger", function userinitializeRun(authService, $http, $location, $state, $rootScope, userinfo, $window, logger) {
  // Asp.net wants the form data in this way. we can't change it.
  /* jshint ignore:start */
  //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
  var urlParams = $location.search();
  if (urlParams.access_token) {
    authService.setToken(
      urlParams.access_token,
      urlParams.refresh_token, urlParams.rememberMe);
  }
  //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
  /* jshint ignore:end */

  // Check for an existing auth token, if one exists ensure the $http module is
  // correctly setup to utilise it on each API request, otherwise redirect the
  // user to the login page.
  var accessToken = authService.getToken();
  if (accessToken) {
    $http.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
  } else {
    //No token. Redirect back to the login page.
    logger.warn('Redirecting to %s due to a missing access token', $window.location.hash);
    $window.location.assign('/login?reason=401&redirect=' + $window.location.hash);
    return;
  }

  var redirectBlock = false;
  $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
    //This is to prevent an infinite redirect loop when showing the service issue page.
    if ((redirectBlock && toState.name == 'FullWidth.ErrorService') || toState.data && toState.data.public) {
      return;
    }

    var accessToken = authService.getToken();
    if (accessToken) {
      $http.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
    } else {
      //No token. Redirect back to the login page.
      event.preventDefault();
      //var redirect = $state.href(toState.name);
      logger.warn('Redirecting during state change due to a missing access token');
      $window.location.assign('/login?reason=401');
      return;
    }

    //Fetch the userinfo if we haven't done so yet.
    if (!userinfo.isInitialized()) {
      event.preventDefault();
      var startupPromise;

      if (urlParams.inviteToken) {
        startupPromise = userinfo.acceptCompanyInvite(urlParams.inviteToken, urlParams.companyName);
      } else {
        startupPromise = userinfo.initialize();
      }

      startupPromise.then(function() {
        redirectBlock = false;
        if (userinfo.countCompanies() === 0) {
          $state.go('Settings.NewCompany');
        } else if (['Blank', 'FullWidth.ErrorService'].indexOf(toState.name) !== -1) {
          userinfo.companyDefaultReport().then(function(defaultReport) {
            $state.go(defaultReport);
          });
        } else {
          $state.go(toState.name, toParams);
        }
      }, function() {
        redirectBlock = true;
        $state.go('FullWidth.ErrorService', {}, {reload: true});
      });
    }
  });

  // var newCompanyCreated = (localStorageService.get('company-created')) ? true : false;
  // var flagVar = (newCompanyCreated) ? 'dismissFlag.welcomeNoPosDialog' : 'dismissFlag.welcomeDialog';
  // var templateVar = (newCompanyCreated) ? 'welcomenoposdialog' : 'welcomedialog';

  // $timeout(function() {
  //   var dismissFlag = localStorageService.get(flagVar);
  //   if (!dismissFlag && newCompanyCreated) {

  //     localStorageService.remove('company-created');
  //     dialog.open({
  //       size: 'lg',
  //       templateUrl: 'dialogs/welcome/' + templateVar + '.tpl.html',
  //       controller: 'WelcomeDialogCtrl'
  //     });

  //   }
  // }, 3000);

}]);
